import Swiper from 'swiper';
import {
	Navigation, Pagination, A11y, EffectFade, Autoplay,
}             from 'swiper/modules';

/**
 * Create a slider using Swiper library
 *
 * @param {HTMLElement} el - The element that contains the slider
 * @param {Object} config - Configuration options for the slider
 * @returns {Swiper|false} - The created Swiper instance
 */
export default function reviews(el, config = {}) {
	// Check if the element exists
	if (!el) {
		return false;
	}
	
	// Get the required elements for the slider
	const slider     = el.querySelector('.swiper');
	const next       = el.querySelector('.swiper-button-next');
	const prev       = el.querySelector('.swiper-button-prev');
	const pagination = el.querySelector('.swiper-pagination');
	
	// Set the default settings for the slider
	const settings = {
		modules               : [Navigation, Pagination, A11y, EffectFade, Autoplay],
		loop                  : false,
		centeredSlides        : true,
		slidesPerView         : 'auto',
		spaceBetween          : 0,
		watchSlidesVisibility : true,
		watchOverflow         : true,
		threshold             : 10,
		observer              : true,
		navigation            : {
			nextEl : next,
			prevEl : prev,
		},
		a11y : {
			prevSlideMessage        : 'Предыдущий слайд',
			nextSlideMessage        : 'Следующий слайд',
			paginationBulletMessage : 'Перейти к {{index}}',
			firstSlideMessage       : 'Первый слайд',
		},
		pagination : {
			el             : pagination,
			type           : 'bullets',
			clickable      : true,
			dynamicBullets : false,
		},
		...config,
	};
	
	// Create and return a new Swiper instance
	return new Swiper(slider, settings);
}
